import Vue from 'vue'
import Vuex from 'vuex'
import language from './modules/language'
import footer from './modules/footer'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    language,
    footer
  }
})

export default store
